import { GridValueFormatterParams } from '@mui/x-data-grid-premium';
import { round2Format, round4Format } from '../../utils/number';

export function gridFormatDecimalString(params: GridValueFormatterParams) {
  const v = params.value;
  if (v == null || v === '') return '';
  const n = typeof v === 'string' ? parseFloat(v) : Number(v);
  return Number.isFinite(n) ? round2Format(n) : String(v);
}

/** Fee amounts can be fractions of a riyal, so show 4 decimals instead of 2. */
export function gridFormatDecimalString4(params: GridValueFormatterParams) {
  const v = params.value;
  if (v == null || v === '') return '';
  const n = typeof v === 'string' ? parseFloat(v) : Number(v);
  return Number.isFinite(n) ? round4Format(n) : String(v);
}
